module.exports = __webpack_public_path__ + "static/media/prawy-gora-atmo.c1843fdc.svg";